import React from 'react';
import InvitationContainer from './InvitationsContainer';

const Invitations = (props) => (
  <InvitationContainer {...props} />
);

export default Invitations;


// WEBPACK FOOTER //
// src/routes/Invitations/index.js